<mat-button-toggle-group class="button-toggle-group" xmlns="http://www.w3.org/1999/html">
    <mat-button-toggle class="settings-header" disabled>
        {{headerName | translate}}:
    </mat-button-toggle>

    <!--    if slider and input have id 1 = height, 2 = age, 3 = weight-->
    <mat-slider #slider class="settings-slider"
                (input)="onSliderChange(slider.value)"
                [(value)]="sliderValue"
                [max]="sliderMax"
                [min]="sliderMin"
                [step]="sliderStep">
    </mat-slider>
    <!--   -->
    <div class="settings-input-label">
        <label *ngIf="headerName == 'Age' && sliderValue>=inputMax" class="settings-label-field">>=</label>
        <div [ngSwitch]="headerName == 'BMI'" class="settings-input-field">
            <div *ngSwitchCase="true">
                <input #inputBMI (input)="onChangeBMI(inputBMI.valueAsNumber)"
                       [step]="0.1"
                       [value]="((sliderValue + 0.3)/0.3 * 5 + 10).toFixed(2)"
                       matInput type="number">

            </div>
            <input #input
                   (input)="onSliderChange(input.valueAsNumber)"
                   *ngSwitchDefault
                   [(ngModel)]="sliderValue"
                   [max]="inputMax"
                   [min]="inputMin"
                   [name]="inputName"
                   [step]="inputStep"
                   matInput
                   type="number">

        </div>
        <label class="settings-label-field">{{unitSlider | translate}}</label>
    </div>
</mat-button-toggle-group>
